import { useState } from 'react'
import { BiLink, BiTrash } from 'react-icons/bi'
import { CMargin, DText, Flex } from '../../../../styles/CommonStyles'
import { UserDetailSettingBox } from '../../../../styles/main/user'
import { useQueryContext } from '../../../../core/contexts/query'
import { useGetAUserViaEmail } from '../../../../core/services/react-query/profile'
import { useUpdateAUser } from '../../../../core/services/react-query/user'
import Input from '../../../common/input/Input'
import ActionButton from '../../../common/buttons/ActionButton'
import Text from '../../../../core/utils/Text'
import { Link } from 'react-router-dom'

const UserAffiliateManagement = ({ user, refetch }) => {
	const { setToast } = useQueryContext()
	const [email, setEmail] = useState('')
	const [actorShare, setActorShare] = useState('100')
	const [objectShare, setObjectShare] = useState('0')
	const [searchedEmail, setSearchedEmail] = useState('')
	const normalizedEmail = email?.trim().toLowerCase();
	const { data, isFetching: isSearching, refetch: findUser } = useGetAUserViaEmail(normalizedEmail)
	const { mutate: updateUser, isLoading } = useUpdateAUser()
	const foundUser = searchedEmail === normalizedEmail ? data : null
	const affiliate = user?.affiliate?.userId ? user?.affiliate : null
	const isDuplicate = !!foundUser && (affiliate?.userId || affiliate?._id) === foundUser._id

	const notifyError = (message) => setToast({ show: true, isError: true, message })
	const getUserPayload = (newAffiliate) => ({
		affiliate: newAffiliate || {}
	})

	const searchUser = () => {
		if (!normalizedEmail) return notifyError('affiliate-email-required')
		setSearchedEmail(normalizedEmail)
		findUser()
	}

	const addAffiliate = () => {
		if (!foundUser?._id) return notifyError('affiliate-user-not-found')
		if (foundUser._id === user?._id) return notifyError('affiliate-self-reference')
		if (isDuplicate) return notifyError('affiliate-already-added')
		if (actorShare === '' || objectShare === '') return notifyError('affiliate-shares-required')

		updateUser({
			id: user?._id,
			data: getUserPayload({ userId: foundUser._id, actorShare: Number(actorShare), objectShare: Number(objectShare) })
		}, {
			onSuccess: () => {
				setEmail('')
				setActorShare('')
				setObjectShare('')
				refetch()
			}
		})
	}

	return (
		<Flex fw justify='center' style={{ padding: '20px' }}>
			<UserDetailSettingBox>
				<DText main><Text tid='affiliate-management-note' /></DText>
				<CMargin margin='10px' />
				<Input value={email} onInputChange={setEmail} label='affiliate-user-email' direction='ltr' />
				<ActionButton active={!!normalizedEmail} onClick={searchUser} loading={isSearching} height='42px'><Text tid='search' /></ActionButton>
				<CMargin margin='8px' />
				{searchedEmail === normalizedEmail && !isSearching && !foundUser && <DText style={{ color: '#d45' }} fontSize='s'><Text tid='affiliate-user-not-found' /></DText>}
				{isDuplicate && <DText style={{ color: '#d45' }} fontSize='s'><Text tid='affiliate-already-added' /></DText>}
				{foundUser && !isDuplicate && <DText main fontSize='s'>{foundUser.email}</DText>}
				<ActionButton active={!!foundUser && actorShare !== '' && objectShare !== ''} onClick={addAffiliate} loading={isLoading}>
					<Text tid='add-affiliate-user' />
				</ActionButton>

				{affiliate && <>
					<CMargin margin='18px' />
					<DText main><Text tid='current-affiliate-users' /></DText>
					<Flex fw justify='space-between' style={{ padding: '10px 0', borderBottom: '1px solid #9993' }}>
						<DText main fontSize='s'>{affiliate?.email || affiliate?.userId || affiliate?._id}</DText>
						<Link to={`/users/${affiliate?.userId}`}>
							<button aria-label='remove-affiliate' style={{ border: 0, background: 'transparent', color: '#0455a1', cursor: 'pointer' }}><BiLink size={20} /></button>
						</Link>
					</Flex>
				</>}
			</UserDetailSettingBox>
		</Flex>
	)
}

export default UserAffiliateManagement
